import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  SpanStyled,
  TextStyled,
} from "../../../styled/Elements";

const DeleteModal = ({ show, onHide, title, onDelete, isLoading}) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} centered>
      <DeleteModalWrapper>
        <Box className="p-4">
          <Box className="mb-4">
            <Box>
              <SpanStyled size="20px" weight={800} color="var(--redColor)">
                {`${t("delete")} ${title}`}
              </SpanStyled>
              <TextStyled size="16px" color="var(--text2)">
                {t(`delete_confirmation`)} {t(title)}?
              </TextStyled>
            </Box>
          </Box>
          <Box className="d-flex justify-content-end">
            <Box className="mt-4 d-flex gap-3">
              <ButtonStyled
                label={t("Cancel")}
                bg={"var(--bgSecondary)"}
                color={"var(--text2)"}
                onClick={onHide}
              />
              <ButtonStyled
                label={t("yes_delete")}
                bg="var(--redColor)"
                onClick={onDelete}
                isLoading={isLoading}
              />
            </Box>
          </Box>
        </Box>
      </DeleteModalWrapper>
    </Modal>
  );
};

export default DeleteModal;

const DeleteModalWrapper = styled.div``;
